import { AreasOfFocus } from 'api/orgs';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/areasOfFocus';

export type State = AreasOfFocus | null | undefined;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function areasOfFocus(state: State = null, action: Action) {
  switch (action.type) {
    case 'AREAS_OF_FOCUS_SET': {
      return action.areasOfFocus;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
